import React from 'react';

export const AuthContext = React.createContext(null);



// WEBPACK FOOTER //
// ./src/app/shared/routing/AuthContext.js